import { useState } from 'react';
import { Card, CardHeader, CardTitle, CardContent, CardFooter, Button } from '@sareto/ui';

export function SettingsPage() {
  const [pixelId, setPixelId] = useState('');
  const [capiToken, setCapiToken] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  
  const handleSave = async () => {
    setIsSaving(true);
    // TODO: Implement save functionality
    await new Promise(resolve => setTimeout(resolve, 1000));
    setIsSaving(false);
  };
  
  return (
    <div className="space-y-8">
      {/* Page header */}
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Settings</h2>
        <p className="text-gray-600 mt-1">
          Configure your Meta integration and tracking settings
        </p>
      </div>

      {/* Meta integration */}
      <Card>
        <CardHeader>
          <CardTitle>Meta Integration</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            <div>
              <label
                htmlFor="pixelId"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Meta Pixel ID
              </label>
              <input
                type="text"
                id="pixelId"
                value={pixelId}
                onChange={(e) => setPixelId(e.target.value)}
                placeholder="Enter your Meta Pixel ID"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                Found in Meta Events Manager under Data Sources
              </p>
            </div>

            <div>
              <label
                htmlFor="capiToken"
                className="block text-sm font-medium text-gray-700 mb-1"
              >
                Conversions API Access Token
              </label>
              <input
                type="password"
                id="capiToken"
                value={capiToken}
                onChange={(e) => setCapiToken(e.target.value)}
                placeholder="Enter your CAPI access token"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              />
              <p className="text-sm text-gray-500 mt-1">
                Generate this token in Meta Events Manager settings
              </p>
            </div>
          </div>
        </CardContent>
        <CardFooter>
          <div className="flex justify-end">
            <Button onClick={handleSave} loading={isSaving}>
              Save Changes
            </Button>
          </div>
        </CardFooter>
      </Card>

      {/* Web Pixel Extension */}
      <Card>
        <CardHeader>
          <CardTitle>Web Pixel Extension</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <p className="text-gray-600">
              The Sareto Web Pixel extension is automatically installed on your Shopify store 
              when you install the app. No manual configuration is required.
            </p>
            
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm font-medium text-gray-700 mb-2">Worker URL</p>
              <code className="text-sm bg-gray-100 px-2 py-1 rounded text-gray-800">
                https://sareto-worker.your-domain.workers.dev
              </code>
              <p className="text-sm text-gray-500 mt-2">
                Events are sent to this worker for server-side processing and Meta CAPI integration.
              </p>
            </div>
          </div>
        </CardContent>
      </Card>

      {/* Subscription */}
      <Card>
        <CardHeader>
          <CardTitle>Subscription</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex items-center justify-between">
            <div>
              <p className="font-medium text-gray-900">Sareto Pro</p>
              <p className="text-gray-600">$49/month - Unlimited conversions</p>
            </div>
            <span className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm font-medium">
              Active
            </span>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

